module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.renderData && _vm.renderData.length && _vm.renderData.length > 1 && !_vm.isDesktop) ? _c('div', {
    staticClass: "categoriesCard minHeightMweb"
  }, [_c('div', {
    staticClass: "categoriesCard__title-cont"
  }, [(_vm.renderName) ? _c('h3', {
    staticClass: "title text-left pl-4"
  }, [_vm._v(_vm._s(_vm.renderName))]) : _vm._e(), _vm._v(" "), (_vm.getDescription) ? _c('p', {
    staticClass: "descrition"
  }, [_vm._v(_vm._s(_vm.getDescription))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "headtop prelative top-banner p-2"
  }, [_c('carousel', {
    ref: "my-carousel",
    class: _vm.isDesktop ? 'bannerview' : 'mobileBannerView',
    attrs: {
      "navigationEnabled": _vm.isDesktop,
      "paginationEnabled": !_vm.isDesktop,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "autoplay": false,
      "speed": 500,
      "perPage": 1,
      "paginationPadding": 1,
      "paginationSize": 6,
      "paginationPosition": 'bottom',
      "paginationColor": '#979a9f'
    }
  }, _vm._l((_vm.getMobileRenderedData), function(renderArr, index) {
    return _c('slide', {
      key: index
    }, _vm._l((renderArr), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "col-6 p-1 "
      }, [_c('router-link', {
        attrs: {
          "to": item.url
        }
      }, [_c('div', {
        directives: [{
          name: "bannerImageLoad",
          rawName: "v-bannerImageLoad",
          value: (_vm.getBannerImpressionData(item, index)),
          expression: "getBannerImpressionData(item, index)"
        }],
        staticClass: "homeCatTile pointer shimmerBg",
        on: {
          "click": function($event) {
            _vm.homeTileRedirection(item, index)
          }
        }
      }, [_c('img', {
        staticClass: "customFade shimmerBg",
        class: _vm.isDesktop ? null : 'img-card',
        staticStyle: {
          "aspect-ratio": "auto 16 / 9"
        },
        attrs: {
          "data-url": _vm.getBannerImage(item.image),
          "alt": item.url
        }
      })])])], 1)
    }))
  }))], 1)]) : (_vm.isDesktop && _vm.renderData && _vm.renderData.length && _vm.renderData.length > 1) ? _c('div', {
    staticClass: "container homeboxes w-100 home-tiles minHeightWeb"
  }, [(_vm.isDesktop && _vm.renderData && _vm.renderData.length && _vm.renderData.length > 1) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "category-heading col-md-12"
  }, [_c('div', {}, [_c('span', [_vm._v(_vm._s(_vm.renderName))])])]), _vm._v(" "), _vm._l((_vm.renderData.slice(0, _vm.renderData.length - 1)), function(item, index) {
    return _c('div', {
      key: item.index,
      staticClass: "bx col-12",
      class: 'col-sm-' + item.col_width
    }, [(item.childs) ? _c('div', {
      staticClass: "row"
    }, _vm._l((item.childs), function(ch, chIndex) {
      return _c('div', {
        key: chIndex + Math.random().toString(),
        staticClass: "bx col-12",
        class: 'col-sm-' + ch.col_width
      }, [_c('div', {
        staticClass: "tilethumb"
      }, [_c('div', {
        directives: [{
          name: "bannerImageLoad",
          rawName: "v-bannerImageLoad",
          value: (_vm.getBannerImpressionData(ch, ((index + 1) + " - " + (chIndex + 1)))),
          expression: "getBannerImpressionData(ch, `${index + 1} - ${chIndex + 1}`)"
        }],
        staticClass: "homeCatTile pointer zoom scaleImg shimmerBg",
        on: {
          "click": function($event) {
            _vm.homeTileRedirection(ch, chIndex)
          }
        }
      }, [_c('div', {
        staticClass: "htilebtn txt-upper fbold"
      }, [_vm._v(_vm._s(ch.product_type))]), _vm._v(" "), _c('img', {
        staticClass: "gtmTileClick customFade shimmerBg",
        staticStyle: {
          "aspect-ratio": "auto 16 / 9"
        },
        attrs: {
          "id": "vests",
          "data-url": _vm.getBannerImage(ch.image_web),
          "alt": ch.product_type
        }
      })])])])
    })) : _c('div', [_c('div', {
      staticClass: "tilethumb"
    }, [_c('router-link', {
      attrs: {
        "to": item.url
      }
    }, [_c('div', {
      directives: [{
        name: "bannerImageLoad",
        rawName: "v-bannerImageLoad",
        value: (_vm.getBannerImpressionData(item, index)),
        expression: "getBannerImpressionData(item, index)"
      }],
      staticClass: "homeCatTile pointer scaleImg zoom shimmerBg",
      on: {
        "click": function($event) {
          _vm.homeTileRedirection(item, index)
        }
      }
    }, [_c('img', {
      staticClass: "gtmTileClick customFade img-auto shimmerBg",
      staticStyle: {
        "aspect-ratio": "auto 16 / 9"
      },
      attrs: {
        "id": "vests",
        "data-url": _vm.getBannerImage(item.image_web),
        "alt": item.product_type,
        "width": "480",
        "height": "480"
      }
    })])])], 1)])])
  })], 2) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5759230a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CarouselGrid2By2.vue
// module id = 2514
// module chunks = 95